<template>
  <div>
    <v-alert type="error" :value="error">{{ error }}</v-alert>

    <statistics-chart
      v-if="chartdata && !loading"
      @changeChartTypeDetail="changeChartTypeDetail"
      :chartdata="chartdata"
      :chartTypeDetailProp="filterParams.chartTypeDetail"
      chartTypeDetailActive
    >
    </statistics-chart>

    <v-layout :wrap="$vuetify.breakpoint.smAndDown">
      <v-flex class="md8 xl9 order-xs2 order-md1">
        <v-data-table
          @update:pagination="updatePagination"
          v-model="selected"
          item-key="radacctid"
          :headers="headers"
          :items="items"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :loading="loading"
          sort-icon="icon icon-arrow-top ml-2"
          next-icon="icon icon-angle-right d-flex align-center"
          prev-icon="icon icon-angle-left d-flex align-center"
          :select-all="true"
          must-sort
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
            >
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  onIcon=""
                  offIcon=""
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.radacctid }}</td>
              <td>{{ props.item.callingstationid }}</td>
              <td>{{ props.item.framedipaddress }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.country }}</td>
              <td>{{ props.item.acctstarttime }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex class="md4 xl3 order-xs1 order-md2 pt-5 mt-2 pl-3 ml-2">
        <sms-mailing
          v-if="filterParams"
          :download="filterParams"
          :phoneSelected="phoneSelected"
          :countAllPhones="countAllPhones"
          type="statisticsGeneral"
          @editSmsDialog="editSmsDialog"
        ></sms-mailing>
        <!-- <div v-if="hotspot" class="layout content-bg--3 pl-4 mb-3">
          <div class="flex md6 font-weight-medium py-4 pl-2">
            {{ hotspot.sms.cntMonth }} СМС
            <label class="subtitle-2 font-weight-regular text--secondary">
              отправлено в рамках тарифа
            </label>
          </div>
          <div class="flex md6 font-weight-medium py-4 pl-3">
            {{ hotspot.sms.sumOverLimit }} СМС
            <label class="subtitle-2 font-weight-regular text--secondary">
              отправлено сверх тарифа
            </label>
          </div>
        </div> -->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";
import StatisticsChart from "./StatisticsChart.vue";
import SmsMailing from "../sms/SmsMailing.vue";
import moment from "moment";

export default {
  name: "StatisticsGeneral",

  components: {
    StatisticsChart,
    SmsMailing
  },

  data: () => ({
    // объект для ошибки
    error: "",
    // статус загрузки
    loading: false,
    // список выбранных строк checkbox-ми
    selected: [],
    // заголовки столбцов таблицы
    headers: [
      {
        text: "Сессия",
        sortable: true,
        value: "radacctid"
      },
      {
        text: "MAC адрес",
        sortable: false,
        value: "callingstationid"
      },
      {
        text: "IP адрес",
        sortable: false,
        value: "framedipaddress"
      },
      {
        text: "Телефон",
        sortable: true,
        value: "username"
      },
      {
        text: "Страна",
        sortable: false,
        value: "country"
      },
      {
        text: "Время",
        sortable: true,
        value: "acctstarttime"
      }
    ],
    // данные таблицы
    items: [],
    // выбор к-ва строк на странице
    rowsPerPageItems: [10, 25, 50],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 10,
      sortBy: "radacctid"
    },
    // данные графика
    chartdata: null,
    // количество уникальных пользователей для отправки смс
    countAllPhones: 0
  }),

  computed: {
    //выбранные номера
    phoneSelected() {
      return new Set(this.selected.map(item => item.username));
    },
    // объект с данными хотспота
    hotspot() {
      return this.$store.getters.getHotspot(this.filterParams.hotspot_id);
    }
  },

  watch: {
    // обновление данных при изменениях фильтра
    filterParams(value) {
      if (value) this.init();
    }
  },

  props: {
    // тип детализации графика
    filterParams: {
      type: Object,
      default: function() {
        return {
          chartTypeDetail: "day",
          hotspotName: "",
          range: {
            startDate: moment().subtract(1, "month"),
            endDate: new Date()
          },
          search: "",
          country: null,
          hotspot_id: null
        };
      }
    }
  },

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad").then(() => {
      this.init();
    });
  },

  methods: {
    /**
     * Инициализация данных
     */
    async init() {
      this.loading = true;
      this.$emit("isLoading", true);
      if (this.$store.getters.hotspotIsLoaded) {
        if (!this.filterParams.hotspot_id || !this.filterParams.hotspotName) {
          this.filterParams.hotspotName = this.$store.getters.hotspotList[0].hotspot_name;
          this.filterParams.hotspot_id = this.$store.getters.hotspotList[0].id;
        }
        await this.filterItems(this.filterParams);
      }
    },

    /**
     * Получение строк из базы
     */
    getList(pagination, filterParams) {
      this.error = "";
      return new Promise((resolve, reject) => {
        RequestApi.statList({
          ...filterParams,
          limit: pagination.rowsPerPage,
          offset:
            pagination.rowsPerPage * pagination.page - pagination.rowsPerPage,
          orderBy: [[pagination.sortBy, pagination.descending ? "DESC" : "ASC"]]
        })
          .then(data => {
            this.items = data.map(item => {
              return {
                ...item,
                country:
                  item.username.substring(0, 1) === "7" ? "Россия" : "Зарубеж"
              };
            });
            resolve();
          })
          .catch(error => {
            this.items = [];
            this.loading = false;
            this.$emit("isLoading", false);
            this.error = error;
            reject();
          });
      });
    },

    /**
     * Получение общего к-во строк из базы
     */
    getListCnt(filterParams) {
      return new Promise((resolve, reject) => {
        RequestApi.statListCnt(filterParams)
          .then(data => {
            this.pagination.totalItems = data.total;
            this.countAllPhones = data.countPhones;
            resolve();
          })
          .catch(error => {
            this.error = error;
            reject();
          });
      });
    },

    /**
     * Срабатывает каждый раз по событиям pagination и sort данных
     * @param pagination
     */
    updatePagination(pagination) {
      // делаем запрос, когда подгрузилось к-во всех строк,
      // не была изменена сортировка либо при смене сортировки ждем когда переключится на 1 страницу
      if (
        this.pagination.totalItems &&
        (this.pagination.sortBy === pagination.sortBy ||
          (this.pagination.sortBy !== pagination.sortBy &&
            pagination.page === 1))
      ) {
        Common.callLastInTime(() => {
          this.getList(pagination, this.filterParams);
        }, 500);
      }
    },

    /**
     * Фильтрация данных
     */
    filterItems(params) {
      // передаем в StatisticsGeneralMain текущие параметры фильтра для сохранения в шаблоны
      this.$emit("setFilter", this.filterParams);
      this.pagination.page = 1;
      this.getListCnt(params).then(() => {
        this.getList(this.pagination, params);
        this.statChartData(params);
      });
    },

    /**
     * Получение данных из базы
     */
    async statChartData(filterParams) {
      let labels = [];

      await RequestApi.statChartData(filterParams)
        .then(data => {
          // сортируем полученный массив по самой ранней дате
          let sortedData = data.sort((a, b) =>
            a.minDate > b.minDate ? 1 : b.minDate > a.minDate ? -1 : 0
          );
          // формируем labels
          if (filterParams.chartTypeDetail === "day") {
            labels = sortedData.map(
              item => `${moment(item.minDate).format("DD.MM.YYYY")}`
            );
          }
          if (filterParams.chartTypeDetail === "week") {
            labels = sortedData.map(
              item =>
                `${moment(item.minDate).format("DD.MM.YYYY")} - ${moment(
                  item.maxDate
                ).format("DD.MM.YYYY")}`
            );
          }
          if (filterParams.chartTypeDetail === "month") {
            labels = sortedData.map(
              item => `${moment(item.minDate).format("MMM YYYY")}`
            );
          }
          if (filterParams.chartTypeDetail === "year") {
            labels = sortedData.map(
              item => `${moment(item.minDate).format("YYYY")}`
            );
          }
          this.chartdata = {
            labels: labels,
            datasets: [
              {
                label: "",
                backgroundColor: "#00CB9A",
                data: sortedData.map(item => item.cnt)
              }
            ]
          };
          this.loading = false;
          this.$emit("isLoading", false);
        })
        .catch(error => {
          this.error = error;
        });
    },

    /**
     * Менят тип детализации графика и
     * перезапускает отрисовку графика
     */
    changeChartTypeDetail(value) {
      this.filterParams.chartTypeDetail = value;
      this.$emit("setFilter", this.filterParams);
      this.statChartData(this.filterParams);
    },

    /**
     * Отправка смс
     */
    editSmsDialog(params) {
      this.$emit("editSmsDialog", params);
    }
  }
};
</script>
